import dynamic from 'next/dynamic'
import { Container, H1 } from '@moneymade/moneymade-ui'
import { useEffect } from 'react'
import PropTypes from 'prop-types'

import CollectionColorCard from 'components/cards/CollectionColorCard/CollectionColorCard'
import styles from './CollectionsPage.module.scss'

const NotFound = dynamic(() => import('components/ui/NotFound/NotFound'))

const CollectionsPage = ({ collections }) => {
  useEffect(() => {
    if (!document.querySelector('[src="https://moneymade.activehosted.com/f/embed.php?id=1"]')) {
      const script = document.createElement('script')

      script.src = 'https://moneymade.activehosted.com/f/embed.php?id=1'
      script.type = 'text/javascript'
      script.charSet = 'utf-8'

      document.head.appendChild(script)

      return () => {
        document.head.removeChild(script)
      }
    }
  }, [])

  return collections?.length ? (
    <Container width={1200} className={styles.CollectionsPage}>
      <div className={styles.Block}>
        <H1 weight="bold" type="heading" className={styles.Title}>
          Collections
        </H1>

        <div className={styles.Collections}>
          {collections.map((collection, index) => (
            <CollectionColorCard key={index} collection={collection} />
          ))}
        </div>
      </div>
    </Container>
  ) : (
    <NotFound text="Collections not found" />
  )
}
CollectionsPage.propTypes = {
  collections: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
      background: PropTypes.string,
      publishedStatus: PropTypes.string,
      metaDescriptionImage: PropTypes.string,
      published: PropTypes.string
    })
  )
}

CollectionsPage.defaultProps = {
  collections: []
}

export default CollectionsPage
